import DrawerButton from "components/form/DrawerButton";
import Error from "components/form/Error";
import InputArea from "components/form/InputArea";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import useVehicleModelSubmit from "hooks/useVehicleModelSubmit";
import SelectVehicleType from "components/form/SelectVehicleType";
import React from "react";
import Scrollbars from "react-custom-scrollbars-2";

const VehicleCategoryDrawer = ({ id }) => {
  const { register, handleSubmit, onSubmit, errors, loading } =
    useVehicleModelSubmit(id);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title title={"Edit Vehicle Model"} description={""} />
        ) : (
          <Title title={"Add Vehicle Model"} description={""} />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-5 pt-5 flex-grow scrollbar-hide w-full max-h-full pb-20">
            <div className="grid grid-cols-12 gap-5 mb-6 items-center">
              <div className="col-span-6">
                <LabelArea required label={"Vehicle Category"} />
                <SelectVehicleType
                  register={register}
                  label="Vehicle Category"
                  name="vehicle_type"
                  type="text"
                  placeholder={"Vehicle Type"}
                />
                <Error errorName={errors.vehicle_type} />
              </div>

              <div className="col-span-6">
                <LabelArea required label={"Vehicle Model"} />
                <InputArea
                  register={register}
                  label="Vehicle Model"
                  name="name"
                  type="text"
                  placeholder={"Vehicle Model"}
                />
                <Error errorName={errors.name} />
              </div>
            </div>
          </div>

          <DrawerButton
            isSubmitting={loading}
            id={id}
            title={id ? "Update" : "Submit"}
          />
        </form>
      </Scrollbars>
    </>
  );
};

export default VehicleCategoryDrawer;
